export default {
    methods: {
        isImage(filename) {
            let ext = this.getExtension(filename)
            return ['bmp', 'gif', 'jpg', 'jpeg', 'png', 'tiff', 'webp' ].includes( ext.toLowerCase() )
        },
        isVideo(filename) {
            let ext = this.getExtension(filename)
            return ['avi', 'mp4', 'mpeg', 'webm'].includes( ext.toLowerCase() )
        },
        isAudio(filename) {
            let ext = this.getExtension(filename)
            return ['aac', 'mp3', 'ogg', 'wav'].includes( ext.toLowerCase() )
        },
        getExtension(filename) {
            if ( filename ) {
                var parts = filename.split('.');
                return parts[parts.length - 1];
            }

            return ''
        },
    }
}
